export default "__VITE_ASSET__bf0c128c__"